/** @jsx jsx */

import { Fragment as _, useState } from 'react';
import { css, jsx } from '@emotion/core';
import { Heart } from './Heart';
import { Diamond } from './Diamond';
import { Smiley } from './Smiley';

const Star = ({
  index,
  rating,
  color,
  selected,
  onHover,
  isHovered,
  onClick,
  shape = 'star',
}) => {
  const [isClicked, setIsClicked] = useState(false);
  const [hasFocus, setHasFocus] = useState(false);
  const size = {
    star: [114, 108],
    heart: [12.9, 12.2],
    diamond: [13.88, 13.88],
    smiley: [12.95, 12.95],
  }[shape] || [114, 108];

  const strokeWidths = {
    star: [3, 1],
    heart: [1, 0.1],
    diamond: [1, 0.1],
    smiley: [1, 0.1],
  }[shape] || [3, 1];

  const styles = {
    fill: `${selected ? color : 'transparent'}`,
    stroke: color,
    strokeWidth: strokeWidths[1], // hasFocus ? strokeWidths[0] :
    transition: 'all 0.2s',

    ...(selected &&
      !isClicked && {
        ':hover': {
          opacity: 0.5,
        },
      }),

    ...((isHovered || isHovered === index) && {
      fill: color,
    }),
  };

  return (
    <div
      css={css`
        position: relative;
        width: ${114 || size[0] / 1.5}px;
        height: ${108 || size[1] / 1.5}px;
        margin: 0 10px;
        transition: all 0.2s;

        @media (max-width: 480px) {
          width: ${114 || size[0] / 2}px;
          height: ${108 || size[1] / 2}px;
          margin: 0 5px;
        }
      `}
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox={`0 0 ${size.join(' ')}`}
        overflow="visible"
      >
        {shape === 'star' && (
          <polygon
            css={css(styles)}
            points="57 88.5 22.32 106.73 28.94 68.12 0.89 40.77 39.66 35.13 57 0 74.34 35.13 113.11 40.77 85.06 68.12 91.68 106.73 57 88.5"
          />
        )}
        {shape === 'heart' && <Heart styles={styles} />}
        {shape === 'diamond' && <Diamond styles={styles} />}
        {shape === 'smiley' && (
          <Smiley
            styles={{
              ...styles,
              fill: color,
            }}
            selected={selected || isHovered || isHovered === index}
          />
        )}
      </svg>
      <button
        aria-label={`star ${index + 1} of 5`}
        aria-pressed={rating == index}
        css={css`
          position: absolute;
          left: 0;
          top: 0;
          width: 100%;
          height: 100%;
          border: none;
          outline: none;
          background: transparent;
          cursor: pointer;
        `}
        onFocus={() => {
          setHasFocus(true);
        }}
        onBlur={() => {
          setHasFocus(false);
        }}
        onClick={() => {
          setIsClicked(true);
          onClick();
        }}
        onMouseOver={() => {
          onHover(index);
        }}
        onMouseOut={() => {
          onHover();
        }}
        onMouseLeave={() => setIsClicked(false)}
      />
    </div>
  );
};

export default Star;
